import type { ItemKind } from "@repo/hindi-shared";
import { letterById, sentenceById, wordById } from "@repo/hindi-shared";

/**
 * Resolve which content bucket an `itemId` belongs to. Checks
 * letters → words → sentences, falling back to "word" for anything
 * unrecognized (defensive; never hit for well-formed plans/rows).
 *
 * Shared by `useSync` (backend `kind` string for push-back rows) and
 * `SessionScreen` (call-site clarity param for `applyGrade`) — kept as a
 * single source of truth so the two call sites can't drift.
 */
export function resolveItemKind(
  itemId: string,
): ItemKind | "word" | "sentence" {
  const letter = letterById.get(itemId);
  if (letter !== undefined) return letter.kind;
  if (wordById.has(itemId)) return "word";
  if (sentenceById.has(itemId)) return "sentence";
  return "word"; // defensive fallback; never hit for well-formed plans
}
